var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"videoView",attrs:{"id":"liveView"}},[_c('video',{ref:"videoRef",staticStyle:{"transform":"scaleX(-1)"},attrs:{"id":"webcamp","autoplay":"","playsinline":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }